import { render } from "./ElementFormDialog.vue?vue&type=template&id=8dbf5470&scoped=true"
import script from "./ElementFormDialog.vue?vue&type=script&lang=js"
export * from "./ElementFormDialog.vue?vue&type=script&lang=js"

import "./ElementFormDialog.vue?vue&type=style&index=0&id=8dbf5470&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbf5470"]])

export default __exports__